module.exports = __webpack_public_path__ + "static/media/kfc-24-2.11008fea.jpg";